import React from 'react';
import logo from './../assets/IFL-Logo.svg'
import vpvlogo from './../assets/VPV-Logo-Azul-Circle.png'
import letter from './../assets/Letter.png'
import cart from './../assets/Shopping-Cart.png'
import { useBrand } from '../contexts/BrandContext';

function PlayerHeader({ currentPlaylistItem }) {
    const { 
        translations: t, 
        isVPVBranded, 
        vpvTheme, 
        customColor, 
        textColor,
        setVpvTheme,
        setCustomColor,
        setTextColor,
        brandConfig
    } = useBrand();

    const isVPV = window.location.origin.includes('visionparavivir.org');
    const displayLogo = (isVPVBranded || isVPV) ? vpvlogo : logo;

    let contentTitle = currentPlaylistItem?.name || '';
    if ((isVPVBranded || isVPV) && t.part) {
        contentTitle = contentTitle.replace(/\bPart\b/gi, t.part);
    }
    const subtitle = currentPlaylistItem?.seriesName || '';
    const dateRange = currentPlaylistItem?.seriesDateRange || '';

    // Features from brand config
    const showColorPicker = brandConfig.features.showColorPicker;

    const seriesURL = currentPlaylistItem?.seriesPage || currentPlaylistItem?.series || '#';
    const purchaseURL = currentPlaylistItem?.series || '#';

    return (
        <div className="player-header-wrapper" style={{ margin: '35px 25px 20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div className="header-top-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <img src={displayLogo} alt="Logo" style={{ maxWidth: '152px', width: '100%' }} />
                </div>

                <div className="header-right" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>
                    <div id="player-header-info" style={{ textAlign: 'right' }}>
                        <h2 style={{ margin: 0, fontSize: '18px' }}>{contentTitle}</h2>
                        {seriesURL !== '#' ? (
                            <a href={seriesURL} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                <h5 style={{ margin: '5px 0 0 0', color: 'rgb(120, 114, 108)', fontSize: '14px', fontWeight: 'normal' }}>{subtitle}</h5>
                            </a>
                        ) : (
                            <h5 style={{ margin: '5px 0 0 0', color: 'rgb(120, 114, 108)', fontSize: '14px', fontWeight: 'normal' }}>{subtitle}</h5>
                        )}
                        {dateRange && <h4 style={{ margin: '5px 0 0 0', color: 'rgb(53, 70, 127)', fontSize: '12px', fontWeight: 'normal' }}>{dateRange}</h4>}
                    </div>
                    <div className="theme-controls" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                        {showColorPicker && (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <span style={{ color: 'var(--vpv-text-color, #000)', fontSize: '12px', fontWeight: 'bold' }}>BG:</span>
                                    <button 
                                        onClick={() => {
                                            setVpvTheme('orange');
                                            setCustomColor('#f15a29');
                                        }}
                                        style={{
                                            width: "20px", height: "20px", backgroundColor: "#f15a29", 
                                            border: vpvTheme === 'orange' ? "2px solid var(--vpv-text-color, #000)" : "1px solid #ccc",
                                            cursor: "pointer", borderRadius: "50%", padding: 0
                                        }}
                                        title="Orange Theme"
                                    />
                                    <button 
                                        onClick={() => {
                                            setVpvTheme('blue');
                                            setCustomColor('#00adf3');
                                        }}
                                        style={{
                                            width: "20px", height: "20px", backgroundColor: "#00adf3", 
                                            border: vpvTheme === 'blue' ? "2px solid var(--vpv-text-color, #000)" : "1px solid #ccc",
                                            cursor: "pointer", borderRadius: "50%", padding: 0
                                        }}
                                        title="Blue Theme"
                                    />
                                    <input 
                                        type="color" value={customColor} 
                                        onChange={(e) => {
                                            setVpvTheme('custom');
                                            setCustomColor(e.target.value);
                                        }}
                                        style={{ width: "24px", height: "24px", padding: 0, cursor: "pointer" }}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <span style={{ color: 'var(--vpv-text-color, #000)', fontSize: '12px', fontWeight: 'bold' }}>Text:</span>
                                    <input 
                                        type="color" value={textColor} 
                                        onChange={(e) => setTextColor(e.target.value)}
                                        style={{ width: "24px", height: "24px", padding: 0, cursor: "pointer" }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className="header-buttons" style={{ display: 'flex', gap: '10px' }}>
                {currentPlaylistItem?.notes && (
                    <a className="btn-header" href={currentPlaylistItem.notes} target="_blank" rel="noreferrer">
                        <img src={letter} alt="icon" style={{ marginRight: '5px' }} />
                        {t.bibleStudy}
                    </a>
                )}
                {currentPlaylistItem?.message && (
                    <a className="btn-header" href={currentPlaylistItem.message} target="_blank" rel="noreferrer">
                        <img src={cart} alt="icon" style={{ marginRight: '5px' }} />
                        {currentPlaylistItem.mediaType === 'video' ? t.video : t.message}
                    </a>
                )}
                {purchaseURL !== '#' && (
                    <a className="btn-header" href={purchaseURL} target="_blank" rel="noreferrer">
                        <img src={cart} alt="icon" style={{ marginRight: '5px' }} />
                        {t.series}
                    </a>
                )}
            </div>
        </div>
    )
}

export default PlayerHeader;
